import React, { useState, useEffect, useCallback } from "react";
import { push } from "connected-react-router";
import { connect } from "react-redux";
import { useIntl } from "react-intl";

import {
  signIn,
  getLastPath,
  changePassword,
  validateSession,
  saveUserSession,
} from "../../modules/session";
import { Token } from "../../modules/httpFunctions";
import LoginForm from "../../components/signIn/loginForm";
import { getUserFromMainSite } from "../../modules/storage";
import { success, error, warn } from "../../modules/messages";
import { setClient } from "../../modules/redux/client/actions";
import ChangePasswordForm from "../../components/signIn/changePasswordForm";

function SignIn({ push, setClient, masterLoading, authenticated }) {
  const [loading, setLoading] = useState(false);

  const [loginForm, setLoginForm] = useState();
  const [passwordForm, setPasswordForm] = useState();
  const saveLoginFormRef = useCallback((formRef) => {
    setLoginForm(formRef);
  }, []);
  const savePasswordFormRef = useCallback((formRef) => {
    setPasswordForm(formRef);
  }, []);

  const intl = useIntl();
  const [currentUserId, setCurrentUserId] = useState();
  const checkPasswordForChange = useCallback(
    (data) => {
      Token.value = data.token;
      setClient(
        data.user.clients &&
          data.user.clients.length > 0 &&
          data.user.clients[0],
      );
      setCurrentUserId(data.user.id);
      warn(
        intl.formatMessage({
          id: "user.expiredPassword",
          defaultMessage: "Vypršela Vám platnost hesla, změňte si jej prosím!",
        }),
        10,
      );
    },
    [intl, setClient],
  );
  useEffect(() => {
    authenticated && push(getLastPath());
  }, [push, authenticated]);

  useEffect(() => {
    getUserFromMainSite((errorMessage, value) => {
      let result = false;
      if (!errorMessage && value) {
        setLoading(true);
        const data = JSON.parse(value);
        if (validateSession(data.token)) {
          saveUserSession(data);
          setCurrentUserId();
          if (data.shouldChangePassword) {
            checkPasswordForChange(data);
          }
          result = true;
        }
      }
      return result;
    });
  }, [checkPasswordForChange]);

  const handleSignIn = useCallback(
    (credentials) => {
      setLoading(true);
      signIn(credentials).then((result) => {
        if (result.success) {
          success(
            intl.formatMessage({
              id: "user.successfulLogin",
              defaultMessage: "Došlo k úspěšnému přihlášení.",
            }),
          );
        } else {
          setLoading(false);
          setCurrentUserId();
          const { data } = result;
          if (data) {
            if (data.data.shouldChangePassword) {
              checkPasswordForChange(data.data);
            } else {
              !data.success && error(data.message);
            }
          } else {
            error(
              intl.formatMessage({
                id: "user.serverError",
                defaultMessage:
                  "Server není dostupný, zkuste prosím přihlášení později!",
              }),
            );
          }
        }
      });
    },
    [intl, checkPasswordForChange],
  );

  const [loginValues, setLoginValues] = useState();
  const handleLoginSubmit = useCallback(
    (e) => {
      e.preventDefault();
      loginForm.validateFields(async (err, values) => {
        if (!err) {
          handleSignIn(values);
          setLoginValues(values);
        }
      });
    },
    [handleSignIn, loginForm],
  );

  const handlePasswordSubmit = useCallback(
    (e) => {
      e.preventDefault();
      passwordForm.validateFields(async (err, values) => {
        if (!err) {
          setLoading(true);
          const result = changePassword(
            loginValues.password,
            values.newPassword,
            values.confirmNewPassword,
            currentUserId,
            setLoading,
            () => {
              Token.value = "";
              handleSignIn({
                username: loginValues.username,
                password: values.newPassword,
              });
            },
          );
          result && passwordForm.setFields(result);
        }
      });
    },
    [passwordForm, currentUserId, loginValues, handleSignIn],
  );

  return currentUserId ? (
    <ChangePasswordForm
      ref={savePasswordFormRef}
      onSubmit={handlePasswordSubmit}
      loading={loading || masterLoading}
    />
  ) : (
    <LoginForm
      ref={saveLoginFormRef}
      onSubmit={handleLoginSubmit}
      loading={loading || masterLoading}
    />
  );
}

const mapStateToProps = ({ session }) => ({
  authenticated: session.authenticated,
});

export default connect(mapStateToProps, {
  setClient,
  push,
})(SignIn);
